import { render, staticRenderFns } from "./BlockBottom.vue?vue&type=template&id=48f966ce&scoped=true&lang=pug&"
import script from "./BlockBottom.vue?vue&type=script&lang=ts&"
export * from "./BlockBottom.vue?vue&type=script&lang=ts&"
import style0 from "./BlockBottom.vue?vue&type=style&index=0&id=48f966ce&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f966ce",
  null
  
)

export default component.exports